export default __webpack_public_path__ + "static/media/mlodz9.a075a603.jpg";